import React from 'react';
import SupplementsLayout from './supplements-layout';

export default class Supplements extends React.Component<{}, {}> {
    render(){
        return(
            <SupplementsLayout/>
        )
    }
}